var escape = require("../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{padding:1rem 0;height:100%;margin:0;background-image:url(" + escape(require("./assets/img/titanium_texture.jpg")) + ");background-size:100% 100%;background-repeat:no-repeat;box-sizing:border-box}#test{width:100%;height:100%;display:flex;justify-content:center}*{font-family:Arial, Helvetica, sans-serif}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/style.scss
// module id = 90
// module chunks = 0